'use client'
import React, { useState, useEffect } from 'react'
import Image from 'next/image'
import { convertImagePath } from '@/library/utils/imagePath'

export default function NextImage(props) {
  const {
    src,
    alt,
    width = "600",
    height = "400",
    className = "",
    priority = false,
    style = {},
    addPadding = false
  } = props

  const base64Image = "data:image/gif;base64,R0lGODlhAQABAIAAAMLCwgAAACH5BAAAAAAALAAAAAABAAEAAAICRAEAOw=="
  let src_ = `${convertImagePath(src)}?tr=${width && `w-${width}`},${height ? `h-${height}` : ""},f-auto,pr-true,${addPadding ? "cm-pad_resize" : ''}`
  const [error, setError] = useState(false)
  const [stateSrc, setStateSrc] = useState(src_)
  const usePlaceHolder = width > 40

  useEffect(() => {
    setError(false)
  }, [src])

  return (
    <>
      {/* {!error && src && ( */}
      <Image
        placeholder={usePlaceHolder ? 'blur' : null}
        blurDataURL={base64Image}
        src={stateSrc}
        width={width}
        height={height}
        alt={alt}
        className={`${className}`}
        priority={priority}
        style={style}
        unoptimized={!priority}
        onError={e => {
          setError(true)
          setStateSrc(base64Image)
        }}
      />
      {/* )} */}
    </>
  )
}
